import { Modal } from 'components/molecules/Modal'
import type { ResetModalProps } from './types'
import { closeModal, cn, getError } from 'lib/utils'
import {
  Button,
  EButtonVariant,
  EButtonStyleVariant,
} from 'components/atoms/Button'
import { Input } from 'components/atoms/Input'
import { FormError } from 'components/atoms/FormError'
import { useResetPasswordForm } from './hooks'

const mainClass = 'form'

export const ResetModal = ({ title, submitButton }: ResetModalProps) => {
  const { formRef, isSubmitting, errors, handleSubmit } =
    useResetPasswordForm()

  return (
    <Modal title={title} onClose={closeModal}>
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className={cn(mainClass, `${mainClass}--new-password`)}
      >
        <FormError message={getError(errors, 'error')} />
        <Input
          placeholder="Email *"
          type="email"
          name="email"
          error={getError(errors, 'email')}
        />

        <Button
          type="submit"
          variant={EButtonVariant.BUTTON}
          buttonVariant={EButtonStyleVariant.PRIMARY}
          disabled={isSubmitting}
        >
          {submitButton}
        </Button>
      </form>
    </Modal>
  )
}
